import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "__cmp_overlay" }, null, -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayerOne = _resolveComponent("LayerOne")!
  const _component_LayerTwo = _resolveComponent("LayerTwo")!
  const _component_LayerThree = _resolveComponent("LayerThree")!
  const _component_LayerNoConsent = _resolveComponent("LayerNoConsent")!
  const _component_LayerStateColorado = _resolveComponent("LayerStateColorado")!
  const _component_LayerStateCalifornia = _resolveComponent("LayerStateCalifornia")!
  const _component_LayerStateConnecticut = _resolveComponent("LayerStateConnecticut")!
  const _component_LayerStateDelaware = _resolveComponent("LayerStateDelaware")!
  const _component_LayerStateIowa = _resolveComponent("LayerStateIowa")!
  const _component_LayerStateMontana = _resolveComponent("LayerStateMontana")!
  const _component_LayerStateNebraska = _resolveComponent("LayerStateNebraska")!
  const _component_LayerStateNewHampshire = _resolveComponent("LayerStateNewHampshire")!
  const _component_LayerStateNewJersey = _resolveComponent("LayerStateNewJersey")!
  const _component_LayerStateOregon = _resolveComponent("LayerStateOregon")!
  const _component_LayerStateTennessee = _resolveComponent("LayerStateTennessee")!
  const _component_LayerStateTexas = _resolveComponent("LayerStateTexas")!
  const _component_LayerStateUtah = _resolveComponent("LayerStateUtah")!
  const _component_LayerStateVirginia = _resolveComponent("LayerStateVirginia")!
  const _component_LayerSimpleAgreeModal = _resolveComponent("LayerSimpleAgreeModal")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          id: "__cmp_body",
          style: _normalizeStyle(_ctx.styleObject)
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerOne')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_LayerOne, {
                      onChangeViewEvent: _ctx.handleChangeView,
                      onStoreTCStringEvent: _ctx.handleStoreTCString,
                      onStoreAcceptAllTCStringEvent: _ctx.handleStoreAcceptAllTCStringEvent,
                      onStoreRejectAllTCStringEvent: _ctx.handleStoreRejectAllTCString
                    }, null, 8, ["onChangeViewEvent", "onStoreTCStringEvent", "onStoreAcceptAllTCStringEvent", "onStoreRejectAllTCStringEvent"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerTwo')
                ? (_openBlock(), _createBlock(_component_LayerTwo, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    onStoreTCStringEvent: _ctx.handleStoreTCString,
                    onStoreAcceptAllTCStringEvent: _ctx.handleStoreAcceptAllTCStringEvent,
                    onStoreRejectAllTCStringEvent: _ctx.handleStoreRejectAllTCString
                  }, null, 8, ["onChangeViewEvent", "onStoreTCStringEvent", "onStoreAcceptAllTCStringEvent", "onStoreRejectAllTCStringEvent"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerThree')
                ? (_openBlock(), _createBlock(_component_LayerThree, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    onStoreTCStringEvent: _ctx.handleStoreTCString,
                    onStoreAcceptAllTCStringEvent: _ctx.handleStoreAcceptAllTCStringEvent,
                    onStoreRejectAllTCStringEvent: _ctx.handleStoreRejectAllTCString
                  }, null, 8, ["onChangeViewEvent", "onStoreTCStringEvent", "onStoreAcceptAllTCStringEvent", "onStoreRejectAllTCStringEvent"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerNoConsent')
                ? (_openBlock(), _createBlock(_component_LayerNoConsent, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    onStoreTCStringEvent: _ctx.handleStoreTCString,
                    onStoreAcceptAllTCStringEvent: _ctx.handleStoreAcceptAllTCStringEvent,
                    onStoreRejectAllTCStringEvent: _ctx.handleStoreRejectAllTCString
                  }, null, 8, ["onChangeViewEvent", "onStoreTCStringEvent", "onStoreAcceptAllTCStringEvent", "onStoreRejectAllTCStringEvent"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateColorado')
                ? (_openBlock(), _createBlock(_component_LayerStateColorado, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateCalifornia')
                ? (_openBlock(), _createBlock(_component_LayerStateCalifornia, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateConnecticut')
                ? (_openBlock(), _createBlock(_component_LayerStateConnecticut, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateDelaware')
                ? (_openBlock(), _createBlock(_component_LayerStateDelaware, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateIowa')
                ? (_openBlock(), _createBlock(_component_LayerStateIowa, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateMontana')
                ? (_openBlock(), _createBlock(_component_LayerStateMontana, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateNebraska')
                ? (_openBlock(), _createBlock(_component_LayerStateNebraska, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateNewHampshire')
                ? (_openBlock(), _createBlock(_component_LayerStateNewHampshire, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateNewJersey')
                ? (_openBlock(), _createBlock(_component_LayerStateNewJersey, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateOregon')
                ? (_openBlock(), _createBlock(_component_LayerStateOregon, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateTennessee')
                ? (_openBlock(), _createBlock(_component_LayerStateTennessee, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateTexas')
                ? (_openBlock(), _createBlock(_component_LayerStateTexas, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateUtah')
                ? (_openBlock(), _createBlock(_component_LayerStateUtah, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateVirginia')
                ? (_openBlock(), _createBlock(_component_LayerStateVirginia, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerSimpleAgreeModal')
                ? (_openBlock(), _createBlock(_component_LayerSimpleAgreeModal, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 4)
      ]))
    : _createCommentVNode("", true)
}